export default __webpack_public_path__ + "static/media/avalanche-tile.ca216491.png";